import { useEffect, useState } from 'react';
import * as LibraryState from '../../state/reducer/library/library';
import * as ProgramService from '../../api/service/programService';

const useFullScreenWorkout = workoutId => {
    const [session, setSession] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [hasServerError, setHasServerError] = useState(false);

    useEffect(() => {
        LibraryState.loadExercises();
    }, []);

    useEffect(
        () => {
            setIsLoading(true);
            setHasServerError(false);

            ProgramService.getWorkoutPreview(workoutId).then(
                response => {
                    if (response && response.id) {
                        setSession(response);
                    } else {
                        setHasServerError(true);
                    }
                    setIsLoading(false);
                },
                () => {
                    setHasServerError(true);
                    setIsLoading(false);
                }
            );
        },
        [workoutId]
    );

    const hasError = hasServerError || (!isLoading && !session);

    return { session, isLoading, hasServerError, hasError };
};

export default useFullScreenWorkout;
